import React from "react";
import { Link } from "react-router-dom";
import "../styles/GoingOut.css";

const APP_STORE = "https://apps.apple.com/us/app/blox-your-campus-in-a-pocket/id6498945325";
const PLAY_STORE = "https://play.google.com/store/apps/details?id=com.schaffen.giggle";

// What the app does to get people out of the house, shown under the hero on the home page.
const features = [
  { emoji: "🙋", title: "I'm free now", text: "Free for a couple of hours? Say so. Your squad sees it, and anyone free too can turn it into a plan." },
  { emoji: "👥", title: "Meet your group first", text: "A day before an event, we put you in a small group of guests with a chat, so you know some faces when you walk in." },
  { emoji: "👯", title: "Double up", text: "Going out with friends? Match your crew with another crew nearby. A group hangout, easier and safer than one-on-one." },
  { emoji: "🫶", title: "See who's going", text: "Spot which of your friends are going to an event or plan before you decide." },
  { emoji: "🎟️", title: "Pass your seat", text: "Can't make it? Give your pass to a friend, or back to the waitlist, so no seat goes empty." },
  { emoji: "🎙️", title: "Echoes", text: "Leave a 30-second voice note at a spot, like the best chai stall or a hidden rooftop. It only plays for people who walk by." },
  { emoji: "📍", title: "I'm here", text: "Check in when you arrive at a plan, so everyone knows who's already there." },
  { emoji: "🧾", title: "Split costs", text: "Log who paid for dinner and cabs. Blox works out who owes whom, so nobody has to." },
];

const GoingOutSection = () => (
  <section className="going-out" aria-labelledby="going-out-title">
    <div className="going-out-inner">
      <p className="going-out-eyebrow">Made for going out</p>
      <h2 id="going-out-title">Less scrolling. More showing up.</h2>
      <p className="going-out-lede">
        Blox helps you actually meet people: find something to do, go with friends (or make some there), and keep the
        people you meet.
      </p>
      <div className="going-out-grid">
        {features.map((f) => (
          <article key={f.title} className="going-out-card">
            <span className="going-out-emoji" aria-hidden="true">{f.emoji}</span>
            <h3>{f.title}</h3>
            <p>{f.text}</p>
          </article>
        ))}
      </div>
      <div className="going-out-cta">
        <Link to="/events" className="going-out-btn going-out-btn-primary">See events</Link>
        <Link to="/plans" className="going-out-btn">Plans near you</Link>
        <a href={APP_STORE} className="going-out-link" target="_blank" rel="noreferrer">App Store</a>
        <a href={PLAY_STORE} className="going-out-link" target="_blank" rel="noreferrer">Google Play</a>
      </div>
    </div>
  </section>
);

export default GoingOutSection;
